<ion-card class="app-background ion-padding">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col size="1" size-md="4" class="steps"></ion-col>
      <ion-col size="10" size-md="4" class="ion-no-padding steps"></ion-col>
      <ion-col size="1" size-md="4" class="steps"></ion-col>
    </ion-row>

    @if (isSuccess()) {
      <ion-row class="ion-justify-content-center ion-text-center">
        <ion-col size="10" size-md="8" size-lg="6">
          <h3 class="ion-padding-horizontal">
            {{ 'activate_step1Succeeded' | translate }}
          </h3>
        </ion-col>
      </ion-row>

      <ion-row class="ion-justify-content-center ion-margin-top">
        <ion-col size="auto">
          <ion-button (click)="goToLogin()">
            <small>{{ 'activate_toApplication' | translate }}</small>
          </ion-button>
        </ion-col>
      </ion-row>
    } @else {
      <ion-row class="ion-justify-content-center ion-text-center">
        <ion-col size="10" size-md="8" size-lg="6">
          <h3 class="ion-padding-horizontal">
            {{ 'activate_step1Failed' | translate }}
          </h3>
        </ion-col>
      </ion-row>
    }
  </ion-grid>
</ion-card>
